import {Ref, watch} from "vue";
import {Pref} from "@/domain/pref.entity";
import {City} from "@/domain/city.entity";
import {useHttpList} from "@/composable/service/useHttp";
import shopHttp from "@/services/http/shop.http";
import useAsyncState from "@/composable/service/useAsyncState";
import {EstateCount} from "@/services/http/shop.http";

export function useGetShopEstateStatistics(filter?: {shopId: Ref<string | string[]>, pref: Ref<Pref | null>, cities: Ref<City[]>}) {
  const http = useHttpList(shopHttp.countEstateTypes);
  const state = useAsyncState(http.request, { default: [] as EstateCount[] });

  if (filter) {
    const { pref, cities, shopId } = filter;
    watch(() => [cities.value], () => {
      if (!pref.value || !pref.value.id || !cities.value.some((item) => !!item.id)) return;
      state.request({ prefId: pref.value.id, cityIds: cities.value.map((item) => item.id) });
    }, { immediate: true });
    watch(shopId, () => {
      if (!shopId.value) return;
      state.request({ shopIds: shopId.value });
    }, { immediate: true });
  }

  return {
    shopEstateStatistics: state.data,
    getShopEstateStatistics: state.request,
    shopEstateStatisticsLoading: state.loading,
    shopEstateStatisticsError: state.error,
  };
}
